export default __webpack_public_path__ + "static/media/ShedularRight.c6867cd6.svg";